import { forwardRef } from 'react';
import styles from './layout.module.css';

const cx = (base: string, extra?: string) =>
  extra ? `${base} ${extra}` : base;

export const InfoModalTitle = forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div ref={ref} className={cx(styles.infoModalTitle, className)} {...props} />
));
InfoModalTitle.displayName = 'InfoModalTitle';

export const InfoModalContainer = forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cx(`${styles.infoModalContainer} u-hide-scrollbar`, className)}
    {...props}
  />
));
InfoModalContainer.displayName = 'InfoModalContainer';

export const InfoModalDescription = forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cx(styles.infoModalDescription, className)}
    {...props}
  />
));
InfoModalDescription.displayName = 'InfoModalDescription';

export const ImageContainer = forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div ref={ref} className={cx(styles.imageContainer, className)} {...props} />
));
ImageContainer.displayName = 'ImageContainer';

export const PricingModal = forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div ref={ref} className={cx(styles.pricingModal, className)} {...props} />
));
PricingModal.displayName = 'PricingModal';

export const Button = forwardRef<
  HTMLButtonElement,
  React.ButtonHTMLAttributes<HTMLButtonElement>
>(({ className, ...props }, ref) => (
  <button ref={ref} className={cx(styles.button, className)} {...props} />
));
Button.displayName = 'Button';
